export default __webpack_public_path__ + "static/media/partner-activate-role.3aae5455.png";